export const RequestDetailsDesktopSteps = [
	{
		selector: '[data-tour="request-list-one"]',
		content: 'A Request card contains all information regarding the request.',
	},
	{
		selector: '[data-tour="request-list-two"]',
		content: 'The unique ID assigned to each request.',
	},
	{
		selector: '[data-tour="request-list-three"]',
		content: 'The title given to each request submitted by the mage.',
	},
	{
		selector: '[data-tour="request-list-four"]',
		content:
			'This number indicates the number of Biobit tokens that are to be paid by the mage for each contribution with	appropriate response.',
	},
	{
		selector: '[data-tour="request-list-five"]',
		content: 'This number indicates the number of approved responses.',
	},
	{
		selector: '[data-tour="request-list-six"]',
		content: 'This number indicates the total number of responses sent to this request.',
	},
	{
		selector: '[data-tour="request-list-seven"]',
		content: 'You can click here to see more information about applying and participating.',
	},
	{
		selector: '[data-tour="request-list-nine"]',
		content:
			'This section displays information about the total number of Biobit tokens, Biobit token name and symbol and your own Wallet balance.',
	},
];

export const RequestDetailsMobileSteps = [
	{
		selector: '[data-tour="request-list-one"]',
		content: 'A Request card contains all information regarding the request.',
	},
	{
		selector: '[data-tour="request-list-two"]',
		content: 'The unique ID assigned to each request.',
	},
	{
		selector: '[data-tour="request-list-three"]',
		content: 'The title given to each request submitted by the mage.',
	},
	{
		selector: '[data-tour="request-list-four"]',
		content:
			'This number indicates the number of Biobit tokens that are to be paid by the mage for each contribution with	appropriate response.',
	},
	{
		selector: '[data-tour="request-list-five"]',
		content: 'This number indicates the number of approved responses.',
	},
	{
		selector: '[data-tour="request-list-six"]',
		content: 'This number indicates the total number of responses sent to this request.',
	},
	{
		selector: '[data-tour="request-list-seven"]',
		content: 'You can click here to see more information about applying and participating.',
	},
];
